{
  "import_layer": {
    "title": "Importar una capa",
    "confirm": "Importar capas"
  },
  "data_fields": {
    "title": "Atributos",
    "add": "Agregar atributo",
    "project_data_fields": "Atributo predefinido",
    "custom_data_field": "Atributo personalizado",
    "type": "Tipo",
    "name": "Nombre del atributo",
    "list_name": "Nombre de la lista",
    "list_items": "Elementos de la lista",
    "list_item": "Elemento de lista",
    "types": {
      "Text": "Texto",
      "List": "Lista",
      "Number": "Número",
      "Date": "Fecha",
      "Tickbox": "Marque la casilla",
      "Time": "Hora",
      "TimeRange": "Rango de tiempo",
      "Image": "Imagen",
      "Hyperlink": "Hiperenlace",
      "RepeatedTimeRanges": "Intervalos de fecha y hora"
    },
    "data_driven_formula": {
      "title": "Crear nueva fórmula",
      "label": "Determine {{ styleProperty }} por",
      "addListItem": "Agregar elemento de lista",
      "searchListItem": "Busca un elemento de la lista"
    }
  },
  "saved_map_view": {
    "default_label": "Convierte esta vista en la predeterminada del plan.",
    "default_description": "Esto define la imagen en miniatura del plan y carga esta vista para todos los usuarios cuando abren el plan.",
    "form_header": "Asigne un nombre a esta vista guardada",
    "name_label": "Nombre de la vista guardada",
    "create_saved_view": "Crear una vista guardada",
    "create_new_saved_view": "Crea una nueva vista guardada",
    "edit_saved_view": "Edita la vista guardada",
    "move_map_around": "Cambia el plan hasta que estés satisfecho con la nueva vista.",
    "save_view_when_ready": "Cuando estés listo, toca «Guardar cambios» para guardar la vista.",
    "map_default": "plan predeterminado"
  },
  "create_map": {
    "create_map": "Crear plan",
    "create_a_map": "Crea un plan",
    "modal_label": "Nombre del plan",
    "create_a_new_map": "Crea un plan nuevo"
  },
  "buttons": {
    "new_layer": "Nueva capa",
    "import_layer": "Importar capa",
    "site_map": "Mapa del sitio",
    "background": "Antecedentes",
    "create_layer": "Crear capa",
    "cancel": "Cancelar",
    "share_table": "Compartir mesa",
    "download_table": "Descargar tabla",
    "toggle_sidebar": "Alternar barra lateral",
    "columns_displayed": "Se muestran las columnas",
    "closePopup": "Cerrar ventana emergente",
    "openBasemapSelector": "Abrir el selector de mapas base",
    "removeSiteMap": "Eliminar el mapa del sitio de la vista"
  },
  "labels": {
    "object": "Objeto",
    "object_id": "ID de objeto",
    "object_name": "Nombre del objeto",
    "layer": "Capa",
    "zone": "Zona",
    "zones": "Zonas",
    "client_group": "Grupo de clientes"
  },
  "nav": {
    "layers": "capas",
    "data_table": "Tabla de datos",
    "sitemap": "Mapa del sitio",
    "background": "Antecedentes",
    "basemap": "Mapa base",
    "background_maps": "Mapas de fondo",
    "selectSitemap": "Selecciona el mapa del sitio",
    "selectLevel": "Seleccione el nivel",
    "search": "Buscar"
  },
  "popup": {
    "view_by_layer": "Ver por capa",
    "view_by_data_field": "Ver por campo de datos",
    "view_by_object": "Ver por objeto",
    "sitemapsAvailableAtThisLocation": "Mapas del sitio disponibles en esta ubicación",
    "closeSitemapSelector": "Cerrar el selector de mapas del",
    "sitemapLevels": "Niveles del mapa",
    "closeLevelSelector": "Cerrar el selector de niveles",
    "saved_map_views": "Vistas guardadas"
  },
  "add_layer": {
    "create_a_new_layer": "Crea una nueva capa",
    "new_layer": "Nueva capa",
    "name_of_layer": "Nombre de la capa",
    "layer_style": "Estilo de capa",
    "layer_style_desc": "Elija un tipo de dibujo o seleccione una plantilla de estilo",
    "drawing_type": "Tipo de dibujo",
    "area": "Área",
    "lines": "Líneas",
    "points": "Puntos",
    "text_labels": "Etiquetas de texto",
    "templates": "Plantillas",
    "shape_and_colour": "Forma y color",
    "line_colour": "Color de línea",
    "fill_opacity": "Opacidad de relleno",
    "preview": "Vista previa",
    "width": "Anchura",
    "offset": "Offset",
    "zones": "Zonas",
    "list_of_options": "Lista de opciones",
    "layer_design": "Diseño de capas",
    "layer_templates": "Plantillas de capas",
    "view_all_templates": "Ver todas las plantillas de capas",
    "scratch": "Inicie una capa desde cero",
    "save_layer": "Guardar capa",
    "type_of_layer": "Tipo de capa",
    "styles": "Estilos",
    "save_style": "Guardar estilo",
    "more": "Más",
    "Line": "Línea",
    "Icon": "Icono",
    "Point": "Punto",
    "Area": "Área",
    "layer_being_created": "Se está creando la capa..."
  },
  "measurements": {
    "unit_of_measurement": "Unidad de medida",
    "imperial": "Imperial",
    "metric": "Métrico"
  },
  "sidebar": {
    "node_name": "El nombre debe tener al menos 2 caracteres"
  },
  "import_layers_tooltip": {
    "Layer": "La capa ya existe en este plan"
  },
  "search": {
    "search_map": "Buscar",
    "locations": "Ubicaciones",
    "objects": "Objetos",
    "search_description": "Busca ubicación, vista guardada, objeto",
    "saved_map_view": "Vistas guardadas",
    "no_results": "No hay resultados que coincidan con tu consulta",
    "sitemaps": "Mapas del sitio"
  }
}